import React from 'react';
import { Box, Button, Typography, Container, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Step3Screen = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '92vh',
        ////background: 'linear-gradient(to right, #f8fafc, #e0f2fe)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Stack spacing={4} alignItems="center" textAlign="center">
          <Typography variant="h4" fontWeight="bold" color="primary.main">
            MisBolos App
          </Typography>

          {/* <Typography variant="h6" color="text.secondary">
            Las pequeñas bandas son las que más importan
          </Typography> */}

          <Typography variant="body1" color="text.primary">
            Descubre bandas y grupos en tu zona
          </Typography>

          <Stack spacing={2} width="100%">
            <Button
              variant="contained"
              color="primary"
              size="large"
              fullWidth
              aria-label="Ver bolos"
              onClick={() => navigate('/misbolos/users')}
              sx={{
                borderRadius: 3,
                py: 1.5,
                fontWeight: 600,
                boxShadow: 2,
                textTransform: 'none',
                fontSize: '1rem',
              }}
            >
              Ver músicos cerca de mí
            </Button>

            <Button
              variant="outlined"
              color="primary"
              size="large"
              fullWidth
              aria-label="Ver grupos"
              onClick={() => navigate('/misbolos/groups')}
              sx={{
                borderRadius: 3,
                py: 1.5,
                fontWeight: 600,
                textTransform: 'none',
                fontSize: '1rem',
              }}
            >
              Ver grupos musicales de mi ciudad
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Step3Screen;
